import React, { Component, useState, useEffect } from 'react';
import Header from "../Landingpagecomponents/Header/header"
import { Grid, Typography, Paper, Icon } from "@material-ui/core";
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Virtus Physio | Your Virtual Physiotherapist
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

function virtual_consultation(props) {
  // Preserve query parameters when loading the assessment iframe
  // Ensure window.location.search exists and is a string before using it
  const queryString = window.location.search || '';
  const iframeSrc = `http://localhost:3000/assessment${queryString}`;
  
  console.log('[embeddedQuestionaire] Query string:', queryString);
  console.log('[embeddedQuestionaire] iframe src:', iframeSrc);
  
  return (
    <Grid container xs={12} style={{ background: "linear-gradient(90deg, #dce4eb, #d7d4cf)", minHeight: "100vh", height: "100vh", position: "relative", display: "flex", flexDirection: "column" }} className="App">
      <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100vh", display: "flex", alignItems: "flex-start", justifyContent: "center" }}>
        <iframe
          style={{
            width: "100vw",
            height: "calc(100vh - 56px + 0px)", // 56px for copyright box, 48px for top padding
            border: "none",
            boxSizing: "border-box",
            display: "block"
          }}
          src={iframeSrc}
          allowFullScreen
        />
      </div>
      <Box
        width="100%"
        style={{
          position: "fixed",
          left: 0,
          bottom: 0,
          background: "#fff",
          zIndex: 10,
          boxShadow: "0 -2px 8px rgba(0,0,0,0.04)",
          padding: "12px 0",
          background: "linear-gradient(90deg, #dce4eb, #d7d4cf)",
        }}
      >
        <Copyright />
      </Box>
    </Grid>
  );
}

function onSubmit(values) {
  console.log(values)
}

export default virtual_consultation;

//<iframe width="100%" height="1200" src="https://virtusphysio.typeform.com/to/G9rBQl" frameborder="0" allowfullscreen></iframe>

//<div>
//<label>First name</label><br />
//<input type="text" name="firstname" id="firstname"/><br /><br />
//</div>